import { useState } from 'react';
import api from '../../api';

export default function SMSPanel({ stores }) {
  const [form, setForm] = useState({ message:'', store_ids:[], only_active:true, min_bonus:'' });
  const [preview, setPreview] = useState(null);
  const [error, setError] = useState('');

  function toggleStore(id) {
    setForm(prev => ({
      ...prev,
      store_ids: prev.store_ids.includes(id)
        ? prev.store_ids.filter(s => s !== id)
        : [...prev.store_ids, id]
    }));
    setPreview(null);
  }

  async function getPreview() {
    setError('');
    try {
      const res = await api.post('/customers/sms/preview', {
        message: form.message,
        store_ids: form.store_ids.length ? form.store_ids : null,
        only_active: form.only_active,
        min_bonus: form.min_bonus || null,
      });
      setPreview(res.data);
    } catch(err) { setError(err.response?.data?.detail || 'Помилка'); }
  }

  async function send() {
    try {
      const res = await api.post('/customers/sms/send', {
        message: form.message,
        store_ids: form.store_ids.length ? form.store_ids : null,
        only_active: form.only_active,
        min_bonus: form.min_bonus || null,
      });
      alert(res.data.status === 'not_configured'
        ? `⚠️ ${res.data.message}\n\nБуде відправлено: ${res.data.would_send_to} клієнтів`
        : `✅ SMS відправлено ${res.data.would_send_to} клієнтам`
      );
    } catch(err) { alert(err.response?.data?.detail || 'Помилка'); }
  }

  return (
    <div style={styles.panel}>
      <h3 style={styles.title}>📱 SMS Розсилка</h3>
      <div style={styles.grid}>
        <div style={styles.left}>
          <label style={styles.label}>Текст повідомлення</label>
          <textarea style={styles.textarea} rows={4}
            placeholder="Вітаємо! Сьогодні знижка 10%..."
            value={form.message}
            onChange={e => { setForm({...form, message:e.target.value}); setPreview(null); }} />
          <div style={styles.charCount}>{form.message.length} символів · {Math.ceil(form.message.length/160)||1} SMS</div>

          <label style={styles.label}>Магазини</label>
          <div style={styles.chips}>
            <div style={{...styles.chip, ...(form.store_ids.length===0 ? styles.chipOn : {})}}
              onClick={() => { setForm({...form, store_ids:[]}); setPreview(null); }}>
              🌐 Вся мережа
            </div>
            {stores.map(s => (
              <div key={s.id}
                style={{...styles.chip, ...(form.store_ids.includes(s.id) ? styles.chipOn : {})}}
                onClick={() => toggleStore(s.id)}>
                🏪 {s.name}
              </div>
            ))}
          </div>

          <div style={styles.filters}>
            <label style={styles.checkLabel}>
              <input type="checkbox" checked={form.only_active}
                onChange={e => setForm({...form, only_active:e.target.checked})} />
              Тільки активні клієнти
            </label>
            <div style={styles.inlineField}>
              <span style={styles.inlineLabel}>Мін. бонусів:</span>
              <input style={styles.smallInput} type="number" placeholder="Будь-яка"
                value={form.min_bonus}
                onChange={e => setForm({...form, min_bonus:e.target.value})} />
            </div>
          </div>

          {error && <p style={styles.error}>{error}</p>}

          <div style={styles.btns}>
            <button style={styles.previewBtn} onClick={getPreview}>👁 Переглянути</button>
            <button style={styles.sendBtn} onClick={send} disabled={!form.message}>📤 Відправити</button>
          </div>
        </div>

        {preview && (
          <div style={styles.previewBox}>
            <div style={styles.previewTitle}>Попередній перегляд</div>
            <div style={styles.previewBig}>{preview.recipients_count}</div>
            <div style={styles.previewSub}>отримувачів · {preview.sms_parts} SMS</div>
            <div style={styles.divider}/>
            {preview.recipients_preview.map((r, i) => (
              <div key={i} style={styles.previewRow}>
                📞 {r.phone}{r.full_name ? ` — ${r.full_name}` : ''}
              </div>
            ))}
            {preview.recipients_count > 5 && (
              <div style={styles.previewMore}>...ще {preview.recipients_count - 5}</div>
            )}
            <div style={styles.divider}/>
            <div style={styles.note}>⚙️ {preview.note}</div>
            <div style={styles.links}>
              {[['TurboSMS','https://turbosms.ua/api.html'],['UniSender','https://unisender.com'],['Infobip','https://infobip.com']].map(([n,u])=>(
                <a key={n} href={u} target="_blank" rel="noreferrer" style={styles.link}>{n} →</a>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

const styles = {
  panel: { background:'#211c14', borderBottom:'1px solid #38301f', padding:'20px 32px' },
  title: { color:'#f5a623', margin:'0 0 16px' },
  grid: { display:'flex', gap:'20px', flexWrap:'wrap' },
  left: { flex:2, minWidth:'280px' },
  label: { display:'block', color:'#9a8a6e', fontSize:'11px', marginBottom:'6px', textTransform:'uppercase', letterSpacing:'0.5px' },
  textarea: { width:'100%', padding:'10px 14px', borderRadius:'8px', border:'1px solid #38301f', background:'#1c1812', color:'#fff', fontSize:'14px', boxSizing:'border-box', resize:'vertical', fontFamily:'inherit' },
  charCount: { color:'#9a8a6e', fontSize:'11px', textAlign:'right', marginBottom:'14px' },
  chips: { display:'flex', flexWrap:'wrap', gap:'8px', marginBottom:'14px' },
  chip: { padding:'6px 14px', background:'#38301f', color:'#9a8a6e', borderRadius:'20px', cursor:'pointer', fontSize:'13px', border:'1px solid #38301f' },
  chipOn: { background:'#1c1812', color:'#f5a623', border:'1px solid #f5a623' },
  filters: { display:'flex', gap:'16px', alignItems:'center', marginBottom:'14px', flexWrap:'wrap' },
  checkLabel: { display:'flex', alignItems:'center', gap:'8px', color:'#9a8a6e', fontSize:'13px', cursor:'pointer' },
  inlineField: { display:'flex', alignItems:'center', gap:'8px' },
  inlineLabel: { color:'#9a8a6e', fontSize:'13px', whiteSpace:'nowrap' },
  smallInput: { width:'100px', padding:'6px 10px', borderRadius:'7px', border:'1px solid #38301f', background:'#1c1812', color:'#fff', fontSize:'13px' },
  error: { color:'#ff6b6b', fontSize:'12px', marginBottom:'8px' },
  btns: { display:'flex', gap:'10px' },
  previewBtn: { padding:'10px 20px', background:'#38301f', color:'#6cb6ff', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'bold' },
  sendBtn: { padding:'10px 20px', background:'#2d6a4f', color:'#5fbf8f', border:'none', borderRadius:'8px', cursor:'pointer', fontWeight:'bold' },
  previewBox: { flex:1, minWidth:'200px', background:'#1c1812', borderRadius:'10px', padding:'16px' },
  previewTitle: { color:'#f5a623', fontWeight:'bold', fontSize:'14px', marginBottom:'12px' },
  previewBig: { fontSize:'32px', fontWeight:'bold', color:'#fff' },
  previewSub: { color:'#9a8a6e', fontSize:'13px', marginBottom:'8px' },
  divider: { height:'1px', background:'#38301f', margin:'10px 0' },
  previewRow: { fontSize:'13px', color:'#cbd5e0', marginBottom:'4px' },
  previewMore: { color:'#9a8a6e', fontSize:'12px', marginTop:'4px' },
  note: { color:'#f5a623', fontSize:'12px', lineHeight:'1.5', marginTop:'8px' },
  links: { display:'flex', gap:'12px', marginTop:'6px', flexWrap:'wrap' },
  link: { color:'#6cb6ff', fontSize:'12px' },
};
